'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseDataService=require('../../../dist-es6/client/services/baseDataService');
const GroupTreeService=require('../../../dist-es6/client/services/groupTreeService');
const treeUtils=require('pulsar-utils/dist-es6/treeUtils');let

GroupBasedDataService=class GroupBasedDataService extends BaseDataService{
constructor($timeout,groupTreeService){
_.ensureInstanceOf(GroupTreeService,groupTreeService);

super($timeout);

this._groupTreeService=groupTreeService;

this._clearCache();
this._clearPersistentData();
}

_clearCache(){
this._groupTree=null;
this._groupsById=null;
}

_clearPersistentData(){
this._selectedGroupData=null;
}

selectGroupDataFor(groupId){
if(!_.exists(this._groupsById)){
this._selectedGroupData=null;
return;
}
this._selectedGroupData=this._groupsById[groupId]||null;
}

get isUserRestrictedFromSeeingAllGroups(){
return this._groupTreeService.isUserRestrictedFromSeeingAllGroups;
}

get selectedGroupData(){

return this._selectedGroupData;
}

get fatigueMeterType(){
return this._fatigueMeterType;
}

set fatigueMeterType(fatigueMeterType){
this._fatigueMeterType=fatigueMeterType;
}

get groupTree(){
return this._groupTree;
}

set groupTree(groupTree){
this._groupTreeService.groupTree=groupTree;
this._groupTree=groupTree;
this._groupsById=_([...treeUtils.flatten(groupTree)]).keyBy(group=>group.id).value();
if(this._groupTreeService.selectedGroup){
this.selectGroupDataFor(this._groupTreeService.selectedGroup.id);
}
}};


module.exports=GroupBasedDataService;
//# sourceMappingURL=groupBasedDataService.js.map
